import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { initMetaPixel } from './lib/metaPixel';
import { initFacebookDomainVerification } from './lib/facebookDomainVerification';
initFacebookDomainVerification();
initMetaPixel();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-116" data-mp="266xvlg65ltja" />);
}